import * as ActionConfigurationManager from './config.actions';

export const loadRates = ActionConfigurationManager.LOAD_RATES;
export const loadRatesHappy = ActionConfigurationManager.LOAD_RATES_HAPPY;
export const ratesLoaded = ActionConfigurationManager.RATES_LOADED;
export const rehydrateRates = ActionConfigurationManager.REHYDRATE_RATES;
export const ratesLoadedFailed = ActionConfigurationManager.RATES_LOADED_FAILED
export const resetRates = ActionConfigurationManager.RESET_RATES
export const saveRatesRequest = ActionConfigurationManager.SAVE_REQUEST